import { RadioButton } from "primereact/radiobutton";
import { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Divider } from "primereact/divider";
import AddTaskQBtn from "./xmotTQSharedComponents/AddTaskQBtn";
import TaskSubQues from "./xmotTQSharedComponents/TaskSubQues";
import {
  AddQuesSkeleton,
  random32BitBinary,
  TQDurations,
} from "../../utils/constants";
import { Dropdown } from "primereact/dropdown";

const radioButtons = [
  {
    id: 1,
    label: "General",
    value: "general",
    showInfoIcon: false,
  },
  {
    id: 2,
    label: "Stimuli/Concept",
    value: "view_stimuli",
    showInfoIcon: true,
  },
];

const surveyRadioButtons = [
  {
    id: 1,
    label: "General",
    value: "general",
    showInfoIcon: false,
  },
  {
    id: 2,
    label: "Capture Photo/Video",
    value: "capture_photo_video",
    showInfoIcon: false,
  },
  // {
  //   id: 3,
  //   label: "Upload Photo/Video",
  //   value: "upload_photo_video",
  //   showInfoIcon: false,
  // },
  {
    id: 4,
    label: "Stimuli/Concept",
    value: "view_stimuli",
    showInfoIcon: true,
  },
  {
    id: 5,
    label: "Screen Capture",
    value: "screen_capture",
    showInfoIcon: false,
  },
  {
    id: 6,
    label: "Barcode Scanner",
    value: "barcode",
    showInfoIcon: false,
  },
];

const uploadPhotoVideoOpt = [
  { label: "Upload Photos", value: "upload_photo" },
  { label: "Upload Videos", value: "upload_video" },
];

const capturePhotoVideoOpt = [
  { label: "Capture Photos", value: "capture_photo" },
  { label: "Capture Videos", value: "capture_video" },
];

const defaultCameraOpt = [
  { label: "Back/Rear camera", value: "0" },
  { label: " Front/Selfie camera", value: "1" },
];

const XmotTask = ({
  taskQuestion,
  index,
  updateTaskItem,
  updateTaskItemWithChildIndex,
  handleAddQuesTask,
  taskQuestions,
  deleteSubTQ,
  setTaskquestion,
  handleShuffle,
  handleImageUpload,
  handleVideoUpload,
  handleVideoThumbUpload,
  isLocked,
  surveyType = "",
  onDeleteSkipLogic,
  deleteSlLoading,
}) => {
  const {
    taskName,
    selectedTaskOption,
    selectedStimuliType,
    instructions,
    subTaskQues,
    taskDuration,
    isError,
    errorMsg,
    stimuliInstructionErrormsg,
    imgFile,
    imgUploadErr,
    isImageUploading,
    isImageUploaded,
    videoUploadErr,
    videoThumbUploadErr,
    isVideoUploading,
    isVideoUploaded,
    isVideoThumbUploading,
    isVideoThumbUploaded,
    selectedUploadPhotoType,
    uploadPhotoVideoInstructions,
    uploadPhotoVideoInstructionsErr,
    skipLogic,
    selectedCaptureType,
    captureCameraPosition,
    captureInstructions,
    captureInstructionsErr,
    screenCaptureInstructions,
    screenCaptureInstructionsErr,
    barcodeInstructions,
    barcodeInstructionsErr,
  } = taskQuestion;

  const subTQItem = JSON.parse(JSON.stringify(AddQuesSkeleton(surveyType)));

  const radioButtonsToRender =
    surveyType === "text" ? surveyRadioButtons : radioButtons;

  const scrollToIndex = useRef(null);
  const uploadPhotoRef = useRef(null);
  const uploadVideoRef = useRef(null);
  const uploadVideoThumbRef = useRef(null);

  const handleAddSubTQ = (index) => {
    let selectedSubTasks = taskQuestions[index]?.subTaskQues;
    console.log("selectedSubTasks", index);
    const questionItem = {
      isSubTQSelected: false,
      question_id: 0,
      qId: `${random32BitBinary()}_${selectedSubTasks.length + 1}`,
      ...subTQItem,
    };
    selectedSubTasks.push(questionItem);

    setTaskquestion((prevProps) =>
      prevProps.map((prevProp, i) => {
        if (i === index) {
          return { ...prevProp, subTaskQues: selectedSubTasks };
        }
        return prevProp;
      }),
    );
    scrollToIndex.current = selectedSubTasks.length - 1;
  };

  const cloneSubTQ = (index, parentindex) => {
    setTaskquestion((prevProps) =>
      prevProps.map((prevProp, i) => {
        if (i === parentindex) {
          let getSelectedItem = prevProp.subTaskQues.find(
            (_data, idx) => idx === index,
          );
          getSelectedItem = {
            ...getSelectedItem,
            question_id: 0,
            qId: `${random32BitBinary()}_${prevProp.subTaskQues.length + 1}`,
          };
          return {
            ...prevProp,
            subTaskQues: [...prevProp.subTaskQues, getSelectedItem],
          };
        }
        return prevProp;
      }),
    );

    scrollToIndex.current = index + 1;
  };

  const updateSubTQItem = (
    subTaskIndex,
    taskIndex,
    updateItem,
    value,
    nestedUpdate,
  ) => {
    if (nestedUpdate) {
      setTaskquestion((prevProps) =>
        prevProps.map((prevProp, i) => {
          if (i === taskIndex) {
            return {
              ...prevProp,
              subTaskQues: prevProp.subTaskQues.map((data, idx) =>
                idx === subTaskIndex
                  ? {
                      ...data,
                      [updateItem]: value,
                    }
                  : data,
              ),
            };
          }
          return prevProp;
        }),
      );
    } else {
      // checkbox updates
      setTaskquestion((prevProps) =>
        prevProps.map((prevProp, i) => {
          if (i === taskIndex) {
            return {
              ...prevProp,
              isSelected:
                value === false
                  ? prevProp.subTaskQues
                      .filter((_, idx) => idx !== subTaskIndex)
                      .every((item) => item.isSubTQSelected === false)
                    ? false
                    : true
                  : value,
              subTaskQues: prevProp.subTaskQues.map((data, idx) =>
                idx === subTaskIndex
                  ? { ...data, isSubTQSelected: value }
                  : data,
              ),
            };
          }
          return prevProp;
        }),
      );
    }
  };

  // const updateSubTQItemNestedPath = (
  //   subTaskIndex,
  //   taskIndex,
  //   updateItem, // e.g. "open_ended_question.instructions.text"
  //   value,
  //   nestedUpdate
  // ) => {
  //   if (nestedUpdate) {
  //     const path = updateItem.split(".");

  //     const updateNested = (obj, keys, val) => {
  //       const [key, ...rest] = keys;

  //       if (!rest.length) {
  //         return { ...obj, [key]: val };
  //       }

  //       return {
  //         ...obj,
  //         [key]: updateNested(obj?.[key] || {}, rest, val),
  //       };
  //     };

  //     setTaskquestion((prevProps) =>
  //       prevProps.map((prevProp, i) => {
  //         if (i !== taskIndex) return prevProp;

  //         return {
  //           ...prevProp,
  //           subTaskQues: prevProp.subTaskQues.map((data, idx) =>
  //             idx === subTaskIndex
  //               ? {
  //                   ...data,
  //                   subTQItem: updateNested(
  //                     data.subTQItem,
  //                     path,
  //                     value
  //                   ),
  //                 }
  //               : data
  //           ),
  //         };
  //       })
  //     );
  //   } else {
  //     // checkbox updates (unchanged, just cleaned)
  //     setTaskquestion((prevProps) =>
  //       prevProps.map((prevProp, i) => {
  //         if (i !== taskIndex) return prevProp;

  //         const updatedSubTaskQues = prevProp.subTaskQues.map((data, idx) =>
  //           idx === subTaskIndex
  //             ? { ...data, isSubTQSelected: value }
  //             : data
  //         );

  //         return {
  //           ...prevProp,
  //           isSelected:
  //             value === false
  //               ? !updatedSubTaskQues.some(
  //                   (item) => item.isSubTQSelected
  //                 )
  //               : value,
  //           subTaskQues: updatedSubTaskQues,
  //         };
  //       })
  //     );
  //   }
  // };

  const updateSubTQItemNestedPath = (
    subTaskIndex,
    taskIndex,
    updateItem, // supports: "a.b.0.c" or "a.b[0].c"
    value,
    nestedUpdate,
  ) => {
    // convert brackets to dot notation: choices[2].text → choices.2.text
    const normalizePath = (path) =>
      path.replace(/\[(\d+)\]/g, ".$1").split(".");

    const updateNested = (obj, keys, val) => {
      const [key, ...rest] = keys;
      const index = Number.isInteger(Number(key)) ? Number(key) : key;

      // base case
      if (!rest.length) {
        if (Array.isArray(obj)) {
          const copy = [...obj];
          copy[index] = val;
          return copy;
        }
        return { ...obj, [index]: val };
      }

      const nextVal =
        obj?.[index] ?? (Number.isInteger(Number(rest[0])) ? [] : {});

      if (Array.isArray(obj)) {
        const copy = [...obj];
        copy[index] = updateNested(nextVal, rest, val);
        return copy;
      }

      return {
        ...obj,
        [index]: updateNested(nextVal, rest, val),
      };
    };

    if (nestedUpdate) {
      const path = normalizePath(updateItem);

      setTaskquestion((prevProps) =>
        prevProps.map((prevProp, i) => {
          if (i !== taskIndex) return prevProp;

          return {
            ...prevProp,
            subTaskQues: prevProp.subTaskQues.map((data, idx) =>
              idx === subTaskIndex
                ? {
                    ...data,
                    ...updateNested(data, path, value),
                  }
                : data,
            ),
          };
        }),
      );
    } else {
      // checkbox logic (unchanged)
      setTaskquestion((prevProps) =>
        prevProps.map((prevProp, i) => {
          if (i !== taskIndex) return prevProp;

          const updatedSubTaskQues = prevProp.subTaskQues.map((data, idx) =>
            idx === subTaskIndex ? { ...data, isSubTQSelected: value } : data,
          );

          return {
            ...prevProp,
            isSelected:
              value === false
                ? !updatedSubTaskQues.some((item) => item.isSubTQSelected)
                : value,
            subTaskQues: updatedSubTaskQues,
          };
        }),
      );
    }
  };

  return (
    <div className="mt-2 mb-4">
      <div className="radio-buttons d-flex align-items-center mb-3">
        {radioButtonsToRender.map((radioButton, idx) => (
          <div
            className="me-3 d-flex align-items-center"
            key={`${index}-${idx}`}
          >
            <RadioButton
              inputId={`${radioButton.label}-${index}`}
              name={`${radioButton.label}-${index}`}
              value={radioButton.value}
              onChange={(e) => updateTaskItem("selectedTaskOption", e.value)}
              checked={selectedTaskOption === radioButton.value}
              disabled={isLocked}
            />
            <label htmlFor={`${radioButton.label}-${index}`} className="ms-2">
              {radioButton.label}
            </label>
            <Tooltip
              className="stimuli-task-tooltip"
              target=".custom-target-icon"
            />
            {radioButton.showInfoIcon ? (
              <i
                className="custom-target-icon ms-2 pi pi-info-circle text-info cursor-pointer"
                data-pr-tooltip="Upload an image or video stimulus"
                data-pr-position="top"
                data-pr-at="center top-8"
              />
            ) : (
              ""
            )}
          </div>
        ))}
      </div>
      {selectedTaskOption === "general" ? (
        <div className="mt-2">
          <div className="d-flex">
            <div className="w-100">
              <InputText
                id="taskName"
                className={`w-100 inputField ${isError ? "error-input" : ""}`}
                autoComplete="off"
                value={taskName}
                placeholder="Task Name"
                name="taskName"
                onChange={(e) => updateTaskItem("taskName", e.target.value)}
              />
              {isError ? (
                <div className="text-start fs-14 text-danger">{errorMsg}</div>
              ) : (
                ""
              )}
            </div>
            <div className="shift-place-icons ms-3">
              <i
                className="pi pi-angle-up cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("up", index, null);
                }}
                disabled={isLocked}
              ></i>
              <span
                style={{
                  borderBottom: "1px solid #9E9E9E",
                  borderTop: "1px solid #9E9E9E",
                  width: "16px",
                  display: "block",
                }}
              ></span>
              <i
                className="pi pi-angle-down cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("down", index, null);
                }}
                disabled={isLocked}
              ></i>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <label className="form-label mb-1 fs-14">Duration:</label>
              <Dropdown
                value={taskDuration}
                onChange={(e) => updateTaskItem("taskDuration", e.value)}
                options={TQDurations}
                optionLabel="name"
                placeholder="Select duration"
                className="w-100 inputField"
                disabled={isLocked}
              />
            </div>
          </div>

          {subTaskQues.length > 0 ? (
            <TaskSubQues
              subTaskQues={subTaskQues}
              taskIndex={index}
              updateTaskItemWithChildIndex={updateTaskItemWithChildIndex}
              updateSubTQItem={updateSubTQItem}
              updateSubTQItemNestedPath={updateSubTQItemNestedPath}
              deleteSubTQ={deleteSubTQ}
              cloneSubTQ={cloneSubTQ}
              handleShuffle={handleShuffle}
              scrollToIndex={scrollToIndex}
              isLocked={isLocked}
              surveyType={surveyType}
              onDeleteSkipLogic={onDeleteSkipLogic}
              deleteSlLoading={deleteSlLoading}
              taskQuestions={taskQuestions}
              parentTask={taskQuestion}
              setTaskquestion={setTaskquestion}
            />
          ) : (
            ""
          )}
          {skipLogic?.length === 0 ? (
            <div className="add-question-btn text-end">
              <Button
                className="add-question-btn fw-bold px-0"
                link
                onClick={() => handleAddSubTQ(index)}
                disabled={isLocked}
              >
                + Add question to this task
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      {selectedTaskOption === "view_stimuli" ? (
        <div className="mt-2 mb-2">
          <Divider />
          <div className="me-3 my-3 d-flex align-items-center">
            <RadioButton
              inputId={"photo"}
              name={"photo"}
              value={"photo"}
              onChange={(e) => updateTaskItem("selectedStimuliType", e.value)}
              checked={selectedStimuliType === "photo"}
              disabled={isLocked}
            />
            <label htmlFor={"photo"} className="ms-2">
              {"Photo"}
            </label>
            <RadioButton
              inputId={"video"}
              name={"video"}
              value={"video"}
              onChange={(e) => updateTaskItem("selectedStimuliType", e.value)}
              checked={selectedStimuliType === "video"}
              className="ms-3"
              disabled={isLocked}
            />
            <label htmlFor={"video"} className="ms-2">
              {"Video"}
            </label>
          </div>

          <div className="d-flex">
            <InputText
              id="task_name"
              className={`w-100 inputField ${isError ? "error-input" : ""}`}
              autoComplete="off"
              value={taskName}
              placeholder="Task Name"
              name="taskName"
              onChange={(e) => updateTaskItem("taskName", e.target.value)}
            />
            <div className="shift-place-icons ms-3">
              <i
                className="pi pi-angle-up cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("up", index, null);
                }}
                disabled={isLocked}
              ></i>
              <span
                style={{
                  borderBottom: "1px solid #9E9E9E",
                  borderTop: "1px solid #9E9E9E",
                  width: "16px",
                  display: "block",
                }}
              ></span>
              <i
                className="pi pi-angle-down cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("down", index, null);
                }}
                disabled={isLocked}
              ></i>
            </div>
          </div>

          <div className="row my-2">
            <div className="col-md-3">
              <label className="form-label mb-1 fs-14">Duration:</label>
              <Dropdown
                value={taskDuration}
                onChange={(e) => updateTaskItem("taskDuration", e.value)}
                options={TQDurations}
                optionLabel="name"
                placeholder="Select duration"
                className="w-100 inputField"
                disabled={isLocked}
              />
            </div>
          </div>

          {selectedStimuliType === "photo" ? (
            <div className="mt-2">
              <div className="col-md-6 col-12">
                <div className="upload label fs-14 mb-2">Photo file</div>
                <div className="d-flex align-items-center">
                  <InputText
                    id="task_name"
                    ref={uploadPhotoRef}
                    type="file"
                    className={`w-100 inputField ${imgUploadErr ? "error-input" : ""}`}
                    placeholder=""
                    onChange={(e) => {
                      updateTaskItem("imgFile", e.target.files[0]);
                      updateTaskItem("imgUploadErr", "");
                    }}
                    disabled={isLocked}
                  />
                  <Button
                    className="add-question-btn createClientBtn d-flex justify-content-center"
                    style={{
                      padding: "12px 24px",
                      borderRadius: "unset",
                    }}
                    onClick={() => uploadPhotoRef.current.click()}
                    disabled={isLocked}
                  >
                    Browse
                  </Button>
                </div>

                <div className="upload-btn-section mt-2">
                  <div className="w-100 upload-btn d-flex align-items-center">
                    <Button
                      className="upload-btn createClientBtn py-0 d-flex justify-content-center fs-14"
                      onClick={handleImageUpload}
                      disabled={isLocked}
                    >
                      {isImageUploading
                        ? "Uploading"
                        : isImageUploaded
                          ? "Uploaded"
                          : "Upload"}
                    </Button>
                    <div className="image-format fs-12 ms-1">
                      Only .jpg and.png image files allowed. Max size of 10MB.
                      Preferred Size: 2560px * 1440px (16:9).
                    </div>
                    {isImageUploaded ? (
                      <Button
                        className="py-0 ps-1 pe-3 fs-14"
                        link
                        disabled={isLocked}
                        onClick={() => {
                          updateTaskItem("photoUrl", "");
                          updateTaskItem("isImageUploaded", false);
                          updateTaskItem("imgFile", null);
                        }}
                      >
                        <i className="pi pi-times fs-12" disabled={isLocked} />
                        Clear
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {imgUploadErr ? (
                  <div className="text-start fs-14 text-danger">
                    {imgUploadErr}
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="fs-14 mb-2 mt-2">
                Instructions for {index + 1} Task:
              </div>
              <InputText
                id="instruction"
                className={`w-100 inputField ${stimuliInstructionErrormsg ? "error-input" : ""}`}
                autoComplete="off"
                value={instructions}
                onChange={(e) => updateTaskItem("instructions", e.target.value)}
              />
              {stimuliInstructionErrormsg ? (
                <div className="text-start fs-14 text-danger">
                  {stimuliInstructionErrormsg}
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div className="row mt-2">
              <div className="col-md-6 col-12">
                <div className="upload label fs-14 mb-2">Video file</div>
                <div className="d-flex align-items-center">
                  <InputText
                    id="video_upload"
                    ref={uploadVideoRef}
                    type="file"
                    className={`w-100 inputField ${videoUploadErr ? "error-input" : ""}`}
                    disabled={isLocked}
                    onChange={(e) => {
                      updateTaskItem("videoFile", e.target.files[0]);
                      updateTaskItem("videoUploadErr", "");
                    }}
                  />
                  <Button
                    className="add-question-btn createClientBtn d-flex justify-content-center"
                    style={{
                      padding: "12px 24px",
                      borderRadius: "unset",
                    }}
                    onClick={() => uploadVideoRef.current.click()}
                    disabled={isLocked}
                  >
                    Browse
                  </Button>
                </div>
                <div className="upload-btn-section mt-2">
                  <div className="w-100 upload-btn d-flex align-items-center">
                    <Button
                      className="upload-btn createClientBtn py-0 d-flex justify-content-center fs-14"
                      onClick={handleVideoUpload}
                      disabled={isLocked}
                    >
                      {isVideoUploading
                        ? "Uploading"
                        : isVideoUploaded
                          ? "Uploaded"
                          : "Upload"}
                    </Button>
                    <div className="image-format fs-12 ms-1">
                      Only .mp4 video files allowed. Max. file size of 100MB.
                    </div>
                    {isVideoUploaded ? (
                      <Button
                        className="py-0 ps-2 pe-2 fs-14"
                        link
                        disabled={isLocked}
                        onClick={() => {
                          updateTaskItem("videoUrl", "");
                          updateTaskItem("isVideoUploaded", false);
                          updateTaskItem("videoFile", null);
                        }}
                      >
                        <i className="pi pi-times fs-12" />
                        Clear
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {videoUploadErr ? (
                  <div className="text-start fs-14 text-danger">
                    {videoUploadErr}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-6 col-12">
                <div className="upload label fs-14 mb-2">
                  Video thumbnail (optional)
                </div>
                <div className="d-flex align-items-center">
                  <InputText
                    id="video_thunb_upload"
                    ref={uploadVideoThumbRef}
                    type="file"
                    className={`w-100 inputField ${videoThumbUploadErr ? "error-input" : ""}`}
                    disabled={isLocked}
                    onChange={(e) => {
                      updateTaskItem("videoThumbnailFile", e.target.files[0]);
                      updateTaskItem("videoThumbUploadErr", "");
                    }}
                  />
                  <Button
                    className="add-question-btn createClientBtn d-flex justify-content-center"
                    style={{
                      padding: "12px 24px",
                      borderRadius: "unset",
                    }}
                    onClick={() => uploadVideoThumbRef.current.click()}
                    disabled={isLocked}
                  >
                    Browse
                  </Button>
                </div>
                <div className="upload-btn-section mt-1">
                  <div className="w-100 upload-btn d-flex align-items-center">
                    <Button
                      className="upload-btn createClientBtn py-0 d-flex justify-content-center fs-14"
                      onClick={handleVideoThumbUpload}
                      disabled={isLocked}
                    >
                      {isVideoThumbUploading
                        ? "Uploading"
                        : isVideoThumbUploaded
                          ? "Uploaded"
                          : "Upload"}
                    </Button>
                    <div className="image-format fs-12 ms-1">
                      Only .jpg and.png image files allowed. Max size of 5MB.
                      Preferred Size: 500px * 281px (16:9).
                    </div>
                    {isVideoThumbUploaded ? (
                      <Button
                        className="py-0 ps-1 pe-3 fs-14"
                        link
                        disabled={isLocked}
                        onClick={() => {
                          updateTaskItem("videoUrl", "");
                          updateTaskItem("isVideoThumbUploaded", false);
                          updateTaskItem("videoThumbnailFile", null);
                        }}
                      >
                        <i className="pi pi-times fs-12" />
                        Clear
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {videoThumbUploadErr ? (
                  <div className="text-start fs-14 text-danger">
                    {videoThumbUploadErr}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
      ) : (
        ""
      )}

      {/* {selectedTaskOption === "upload_photo_video" && surveyType === "text" ? (
        <div className="mt-2 mb-2">
          <Divider />

          <div className="radio-buttons d-flex align-items-center mb-4 mt-3">
            {uploadPhotoVideoOpt.map((radioButton, index) => (
              <div className="me-3 d-flex align-items-center" key={index}>
                <RadioButton
                  inputId={radioButton.label}
                  name={radioButton.label}
                  value={radioButton.value}
                  onChange={(e) => {
                    updateTaskItem("selectedUploadPhotoType", e.value);
                    updateTaskItem(
                      "uploadPhotoVideoInstructions",
                      `Please upload ${e.value === "upload_photo" ? "photo(s)" : "video(s)"} using the button provided`,
                    );
                  }}
                  checked={selectedUploadPhotoType === radioButton.value}
                  disabled={isLocked}
                />
                <label htmlFor={radioButton.label} className="ms-2">
                  {radioButton.label}
                </label>
              </div>
            ))}
          </div>

          <div className="d-flex">
            <div className="w-100">
              <InputText
                id="taskName"
                className={`w-100 inputField ${isError ? "error-input" : ""}`}
                autoComplete="off"
                value={taskName}
                placeholder="Task Name"
                name="taskName"
                onChange={(e) => updateTaskItem("taskName", e.target.value)}
              />
              {isError ? (
                <div className="text-start fs-14 text-danger">{errorMsg}</div>
              ) : (
                ""
              )}
            </div>
            <div className="shift-place-icons ms-3">
              <i
                className="pi pi-angle-up cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("up", index, null);
                }}
                disabled={isLocked}
              ></i>
              <span
                style={{
                  borderBottom: "1px solid #9E9E9E",
                  borderTop: "1px solid #9E9E9E",
                  width: "16px",
                  display: "block",
                }}
              ></span>
              <i
                className="pi pi-angle-down cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("down", index, null);
                }}
                disabled={isLocked}
              ></i>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <label className="form-label mb-1 fs-14">Duration:</label>
              <Dropdown
                value={taskDuration}
                onChange={(e) => updateTaskItem("taskDuration", e.value)}
                options={TQDurations}
                optionLabel="name"
                placeholder="Select duration"
                className="w-100 inputField"
                disabled={isLocked}
              />
            </div>
          </div>

          <div className="fs-14 mb-2 mt-2">
            Instructions for {index + 1} Task:
          </div>
          <InputText
            id="instruction-upload"
            className={`w-100 inputField ${uploadPhotoVideoInstructionsErr ? "error-input" : ""}`}
            autoComplete="off"
            value={uploadPhotoVideoInstructions}
            onChange={(e) =>
              updateTaskItem("uploadPhotoVideoInstructions", e.target.value)
            }
          />
          {uploadPhotoVideoInstructionsErr ? (
            <div className="text-start fs-14 text-danger">
              {uploadPhotoVideoInstructionsErr}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )} */}

      {selectedTaskOption === "capture_photo_video" && surveyType === "text" ? (
        <div className="mt-2 mb-2">
          <Divider />

          <div className="radio-buttons d-flex align-items-center mb-4 mt-3">
            {capturePhotoVideoOpt.map((radioButton, index) => (
              <div className="me-3 d-flex align-items-center" key={index}>
                <RadioButton
                  inputId={radioButton.label}
                  name={radioButton.label}
                  value={radioButton.value}
                  onChange={(e) => {
                    updateTaskItem("selectedCaptureType", e.value);
                    updateTaskItem(
                      "captureInstructions",
                      `Please capture ${e.value === "upload_photo" ? "photo(s)" : "video(s)"} using the button provided`,
                    );
                  }}
                  checked={selectedCaptureType === radioButton.value}
                  disabled={isLocked}
                />
                <label htmlFor={radioButton.label} className="ms-2">
                  {radioButton.label}
                </label>
              </div>
            ))}
          </div>

          <div className="form-label mb-1 fs-14 mt-3">Default camera:</div>
          <div className="radio-buttons d-flex align-items-center mb-4">
            {defaultCameraOpt.map((radioButton, index) => (
              <div className="me-3 d-flex align-items-center" key={index}>
                <RadioButton
                  inputId={radioButton.label}
                  name={radioButton.label}
                  value={radioButton.value}
                  onChange={(e) => {
                    updateTaskItem("captureCameraPosition", e.value);
                    updateTaskItem(
                      "captureInstructions",
                      `Please upload ${e.value === "upload_photo" ? "photo(s)" : "video(s)"} using the button provided`,
                    );
                  }}
                  checked={captureCameraPosition === radioButton.value}
                  disabled={isLocked}
                />
                <label htmlFor={radioButton.label} className="ms-2">
                  {radioButton.label}
                </label>
              </div>
            ))}
          </div>

          <div className="d-flex">
            <div className="w-100">
              <InputText
                id="taskName"
                className={`w-100 inputField ${isError ? "error-input" : ""}`}
                autoComplete="off"
                value={taskName}
                placeholder="Task Name"
                name="taskName"
                onChange={(e) => updateTaskItem("taskName", e.target.value)}
              />
              {isError ? (
                <div className="text-start fs-14 text-danger">{errorMsg}</div>
              ) : (
                ""
              )}
            </div>
            <div className="shift-place-icons ms-3">
              <i
                className="pi pi-angle-up cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("up", index, null);
                }}
                disabled={isLocked}
              ></i>
              <span
                style={{
                  borderBottom: "1px solid #9E9E9E",
                  borderTop: "1px solid #9E9E9E",
                  width: "16px",
                  display: "block",
                }}
              ></span>
              <i
                className="pi pi-angle-down cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("down", index, null);
                }}
                disabled={isLocked}
              ></i>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <label className="form-label mb-1 fs-14">Duration:</label>
              <Dropdown
                value={taskDuration}
                onChange={(e) => updateTaskItem("taskDuration", e.value)}
                options={TQDurations}
                optionLabel="name"
                placeholder="Select duration"
                className="w-100 inputField"
                disabled={isLocked}
              />
            </div>
          </div>

          <div className="fs-14 mb-2 mt-2">
            Instructions for {index + 1} Task:
          </div>
          <InputText
            id="instruction-upload"
            className={`w-100 inputField ${captureInstructionsErr ? "error-input" : ""}`}
            autoComplete="off"
            value={captureInstructions}
            onChange={(e) =>
              updateTaskItem("captureInstructions", e.target.value)
            }
          />
          {captureInstructionsErr ? (
            <div className="text-start fs-14 text-danger">
              {captureInstructionsErr}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      {selectedTaskOption === "screen_capture" && surveyType === "text" ? (
        <div className="mt-2 mb-2">
          <div className="d-flex">
            <div className="w-100">
              <InputText
                id="taskName"
                className={`w-100 inputField ${isError ? "error-input" : ""}`}
                autoComplete="off"
                value={taskName}
                placeholder="Task Name"
                name="taskName"
                onChange={(e) => updateTaskItem("taskName", e.target.value)}
              />
              {isError ? (
                <div className="text-start fs-14 text-danger">{errorMsg}</div>
              ) : (
                ""
              )}
            </div>
            <div className="shift-place-icons ms-3">
              <i
                className="pi pi-angle-up cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("up", index, null);
                }}
                disabled={isLocked}
              ></i>
              <span
                style={{
                  borderBottom: "1px solid #9E9E9E",
                  borderTop: "1px solid #9E9E9E",
                  width: "16px",
                  display: "block",
                }}
              ></span>
              <i
                className="pi pi-angle-down cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("down", index, null);
                }}
                disabled={isLocked}
              ></i>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <label className="form-label mb-1 fs-14">Duration:</label>
              <Dropdown
                value={taskDuration}
                onChange={(e) => updateTaskItem("taskDuration", e.value)}
                options={TQDurations}
                optionLabel="name"
                placeholder="Select duration"
                className="w-100 inputField"
                disabled={isLocked}
              />
            </div>
          </div>

          <div className="fs-14 mb-2 mt-2">
            Instructions for {index + 1} Task:
          </div>
          <InputText
            id="instruction-upload"
            className={`w-100 inputField ${screenCaptureInstructionsErr ? "error-input" : ""}`}
            autoComplete="off"
            value={screenCaptureInstructions}
            onChange={(e) =>
              updateTaskItem("screenCaptureInstructions", e.target.value)
            }
          />
          {screenCaptureInstructionsErr ? (
            <div className="text-start fs-14 text-danger">
              {screenCaptureInstructionsErr}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      {selectedTaskOption === "barcode" && surveyType === "text" ? (
        <div className="mt-2 mb-2">
          <div className="d-flex">
            <div className="w-100">
              <InputText
                id="taskName"
                className={`w-100 inputField ${isError ? "error-input" : ""}`}
                autoComplete="off"
                value={taskName}
                placeholder="Task Name"
                name="taskName"
                onChange={(e) => updateTaskItem("taskName", e.target.value)}
              />
              {isError ? (
                <div className="text-start fs-14 text-danger">{errorMsg}</div>
              ) : (
                ""
              )}
            </div>
            <div className="shift-place-icons ms-3">
              <i
                className="pi pi-angle-up cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("up", index, null);
                }}
                disabled={isLocked}
              ></i>
              <span
                style={{
                  borderBottom: "1px solid #9E9E9E",
                  borderTop: "1px solid #9E9E9E",
                  width: "16px",
                  display: "block",
                }}
              ></span>
              <i
                className="pi pi-angle-down cursor-pointer"
                onClick={() => {
                  if (isLocked) {
                    return false;
                  }
                  handleShuffle("down", index, null);
                }}
                disabled={isLocked}
              ></i>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <label className="form-label mb-1 fs-14">Duration:</label>
              <Dropdown
                value={taskDuration}
                onChange={(e) => updateTaskItem("taskDuration", e.value)}
                options={TQDurations}
                optionLabel="name"
                placeholder="Select duration"
                className="w-100 inputField"
                disabled={isLocked}
              />
            </div>
          </div>

          <div className="fs-14 mb-2 mt-2">
            Instructions for {index + 1} Task:
          </div>
          <InputText
            id="instruction-upload"
            className={`w-100 inputField ${barcodeInstructionsErr ? "error-input" : ""}`}
            autoComplete="off"
            value={barcodeInstructions}
            onChange={(e) =>
              updateTaskItem("barcodeInstructions", e.target.value)
            }
          />
          {barcodeInstructionsErr ? (
            <div className="text-start fs-14 text-danger">
              {barcodeInstructionsErr}
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      <div className="add-question-btn text-end">
        {index === taskQuestions.length - 1 ? (
          ""
        ) : (
          <AddTaskQBtn
            handleAddQuesTask={handleAddQuesTask}
            isLocked={isLocked}
          />
        )}
      </div>
    </div>
  );
};

export default XmotTask;
